import { Content } from '@the-game/components'
import { breakpoint } from '@the-game/components/utils'
import styled from '@emotion/styled'

export const StaticContentPage = styled(Content)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    section: {
        marginBottom: theme.spacing.xl,
        marginTop: theme.spacing.lg,

        [breakpoint('md')]: {
            marginTop: theme.spacing.xl,
            marginBottom: theme.spacing.xxxl,
        },
        [breakpoint('lg')]: {
            marginBottom: theme.spacing.xxxxl,
        },
        'h2 + h3': {
            marginTop: theme.spacing.lg,
        },
        '> h3': {
            marginTop: theme.spacing.xxxl,
        },
    },
}))
